export default {
  'menu.welcome': 'خوش آمدید',
  'menu.more-blocks': 'بلوک های بیشتر',
  'menu.home': 'خانه',
  'menu.admin': 'مدیر',
  'menu.admin.sub-page': 'زیر صفحه',
  'menu.login': 'ورود',
  'menu.register': 'ثبت نام',
  'menu.register-result': 'ثبت نام نتیجه',
  'menu.dashboard': 'داشبورد',
  'menu.dashboard.analysis': 'تحلیل و بررسی',
  'menu.dashboard.monitor': 'نظارت',
  'menu.dashboard.workplace': 'محل کار',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'فرم',
  'menu.form.basic-form': 'فرم اساسی',
  'menu.form.step-form': 'فرم مرحله',
  'menu.form.step-form.info': 'فرم مرحله (نوشتن اطلاعات انتقال)',
  'menu.form.step-form.confirm': 'فرم مرحله (تأیید اطلاعات انتقال)',
  'menu.form.step-form.result': 'فرم مرحله (تمام شده)',
  'menu.form.advanced-form': 'فرم پیشرفته',
  'menu.list': 'لیست',
  'menu.list.table-list': 'جدول جستجو',
  'menu.list.basic-list': 'لیست اصلی',
  'menu.list.card-list': 'لیست کارت',
  'menu.list.search-list': 'لیست جستجو',
  'menu.list.search-list.articles': 'لیست جستجو (مقالات)',
  'menu.list.search-list.projects': 'لیست جستجو (پروژه ها)',
  'menu.list.search-list.applications': 'لیست جستجو (برنامه ها)',
  'menu.profile': 'مشخصات',
  'menu.profile.basic': 'مشخصات عمومی',
  'menu.profile.advanced': 'مشخصات پیشرفته',
  'menu.result': 'نتیجه',
  'menu.result.success': 'موفق',
  'menu.result.fail': 'ناموفق',
  'menu.exception': 'استثنا',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'راه اندازی',
  'menu.account': 'حساب',
  'menu.account.center': 'مرکز حساب',
  'menu.account.settings': 'تنظیمات حساب',
  'menu.account.trigger': 'خطای راه اندازی',
  'menu.account.logout': 'خروج',
  'menu.editor': 'ویرایشگر گرافیک',
  'menu.editor.flow': 'ویرایشگر جریان',
  'menu.editor.mind': 'ویرایشگر ذهن',
  'menu.editor.koni': 'ویرایشگر Koni',

  // 建銀智能評估系統菜單
  'menu.operations': 'Operations Overview',
  'menu.customer': 'Customer Management',
  'menu.customer.customerAdd': 'Add Customer',
  'menu.customer.customerEdit': 'Edit Customer',
  'menu.task': 'Task Management',
  'menu.report': 'Report Management',
  'menu.activity': 'Activity Management',
  'menu.finance': 'Finance Management',
  'menu.platform': 'Platform Maintenance',
  'menu.netValueSolution': 'Net Value Solution',
  'menu.ledger': 'Ledger Management',
  'menu.system': 'System Management',

  // 系統管理子菜單
  'menu.organization': 'Organization Management',
  'menu.logs': 'Operation Logs',
  'menu.user': 'User Management',
  'menu.personal': 'Personal Settings',
  'menu.role': 'Role Management',
  'menu.settings': 'System Settings',

  // 完整的系統管理子菜單路徑
  'menu.system.organization': 'Organization Management',
  'menu.system.logs': 'Operation Logs',
  'menu.system.user': 'User Management',
  'menu.system.userCreate': 'Add User',
  'menu.system.userEdit': 'Edit User',
  'menu.system.personal': 'Personal Settings',
  'menu.system.role': 'Role Management',
  'menu.system.roleCreate': 'Add Role',
  'menu.system.permission': 'Permission Management',
  'menu.system.menu': 'Menu Configuration',
  'menu.system.settings': 'System Settings',

  // 完整的任務管理子菜單路徑
  'menu.task.taskMyTask': 'My Tasks',
  'menu.task.taskStatistics': 'Task Statistics',
  'menu.task.taskSupplement': 'Task Supplement',
  'menu.task.taskCreate': 'Create Task',
  'menu.task.reportReview': 'My Review',
  'menu.task.reportDetail': 'Report Details',

  // 完整的報告管理子菜單路徑
  'menu.report.reportStatistics': 'Report Statistics',
  'menu.report.reportDetail': 'Report Details',

  // Net value solution submenu
  'menu.netValueSolution.netValueSolutionAdd': 'Add Net Value Solution',
  'menu.netValueSolution.netValueSolutionList': 'Net Value Solution List',
  'menu.netValueSolution.netValueSolutionCommonParams': 'Common Parameters',
  'menu.netValueSolution.netValueSolutionPlanCustomParams':
    'Plan Custom Parameters',
  'menu.netValueSolutionAdd': 'Add Net Value Solution',
  'menu.netValueSolutionList': 'Net Value Solution List',
  'menu.netValueSolutionCommonParams': 'Common Parameters',
  'menu.netValueSolutionPlanCustomParams': 'Plan Custom Parameters',

  // Ledger submenu
  'menu.ledger.ledgerList': 'Ledger List',
  'menu.ledgerList': 'Ledger List',
  'menu.ledger.ledgerInquiry': 'Inquiry Ledger',
  'menu.ledgerInquiry': 'Inquiry Ledger',
  'menu.ledger.ledgerEdit': 'Edit Ledger',
  'menu.ledgerEdit': 'Edit Ledger',
};
